import { render, staticRenderFns } from "./RewardsCenter.vue?vue&type=template&id=24c39567&scoped=true"
import script from "./RewardsCenter.vue?vue&type=script&lang=js"
export * from "./RewardsCenter.vue?vue&type=script&lang=js"
import style0 from "./RewardsCenter.vue?vue&type=style&index=0&id=24c39567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c39567",
  null
  
)

export default component.exports